/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business design-search の検索中ローディング。結果グリッドと同形の 6 枚スケルトン + fassychan turntable GIF を上部に重ねる装飾
 * @graph-connects none
 */
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@cortex/web-design-system/components/ui/Skeleton';
import designSearchLoadingGif from '../../../assets/design-search-loading.gif';

/** @graph-connects none */
export function DesignSearchGridSkeleton() {
  const { t } = useTranslation();
  return (
    <div className="relative" role="status" aria-live="polite">
      {/* 本体（結果グリッド）と同形のスケルトンで layout jump を防ぐ */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }, (_, i) => (
          <Skeleton key={i} className="h-56 w-full rounded-xl" />
        ))}
      </div>
      {/* fassychan の turntable を骨格の上部に小さく重ねる（装飾。状態は下のテキストが担う）。
          モバイル（1 列）は骨格が縦に長く、中央寄せだと GIF/文言が初期表示外に落ちるため上端寄せに固定する。 */}
      <div className="pointer-events-none absolute inset-0 flex items-start justify-center pt-8 sm:pt-16">
        <div className="flex flex-col items-center gap-2 rounded-2xl bg-[var(--color-bg-surface)] px-6 py-4 shadow-sm">
          <img
            src={designSearchLoadingGif}
            alt=""
            aria-hidden="true"
            className="h-28 w-28 object-contain motion-reduce:hidden sm:h-32 sm:w-32"
          />
          <span className="text-sm text-[var(--color-text-muted)]">
            {t('designSearch.loading')}
          </span>
        </div>
      </div>
    </div>
  );
}
